import { render, staticRenderFns } from "./select-service_name-inventory.vue?vue&type=template&id=86974c2c&"
import script from "./select-service_name-inventory.vue?vue&type=script&lang=js&"
export * from "./select-service_name-inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports